import { Route } from 'react-router';
import { OpcoOrganizationsPage } from '../OpcoOrganizationsPage';
import { getOpcoOrganizationsPath } from '../path/path';

export const OrganizationsRoutes = [
  <Route key={getOpcoOrganizationsPath()} path={getOpcoOrganizationsPath()} element={<OpcoOrganizationsPage />} />,
];
